<template>
  <div class="app-header-wrap">
    <el-row id="app-header">
      <!-- 宽度固定 -->
      <el-col :sm="24" :md="8" :lg="8">
        <div class="title-wrap">
          <router-link :to="{ name: 'Home' }" class="home">
            <!-- <div class="logo">
              <img :src="logoUrl">
            </div> -->
            <div v-if="customer != undefined" class="title">{{ customer.value }}</div>
            <div v-if="project != undefined" class="title">{{ project.value }}</div>
          </router-link>
        </div>
      </el-col>
      <!-- 宽度与avatar互调 -->
      <!-- <el-col :sm="24" :md="10" :lg=" logined ? 8:10"> -->
      <el-col :sm="24" :md="10" :lg="11">
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          background-color="#000"
          text-color="#fff"
          active-text-color="#fff"
          :router="true"
        >
          <el-menu-item index="0" :route="{ name: 'Home' }"> 首页 </el-menu-item>
          <el-menu-item
            v-for="(menu, index) in menuList"
            :key="menu.sort"
            :index="index + 1 + ''"
            :route="{ name: 'ResourceList', query: { type: menu.field } }"
          >
            {{ menu.title }}
          </el-menu-item>
        </el-menu>
      </el-col>
      <!-- 搜索 -->
      <el-col :sm="24" :md="12" :lg="5" style="background-color: #000;text-align:center;">
        <el-form
          ref="searchForm"
          :model="keyword"
          :rules="searchRules"
          size="small"
          style="height: 48px; padding-top: 12px;float:left;"
          @submit.native.prevent="search"
        >
          <el-form-item prop="content">
            <el-input v-model="keyword.content" placeholder="检索内容" class="search-input">
              <el-select
                slot="prepend"
                v-model="keyword.scope"
                placeholder="搜索范围"
                style="width: 75px; height: 30px; background-color: #fff; color: #000"
              >
                <el-option v-for="scope in searchScope" :key="scope.value" :value="scope.value" :label="scope.label" />
              </el-select>
              <el-button
                slot="append"
                native-type="submit"
                icon="el-icon-search"
                style="background: none;background-color:#fff width: 50px"
              />
            </el-input>
          </el-form-item>
        </el-form>
        <!-- <el-button type="text" style="float:left;width:70px;margin-top:10px;" @click="$router.push({name:'AdvSearch'})">
          高级检索
        </el-button> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '0',
      keyword: {
        scope: 'subject',
        content: ''
      },
      searchScope: [
        { value: 'subject', label: '主题' },
        { value: 'person', label: '人物' },
        { value: 'text', label: '全文' }
      ],
      searchRules: {
        content: [{ required: true, message: '请输入搜索词', trigger: 'blur' }]
      },
      logined: false,
      username: ''
    }
  },
  computed: {
    ...mapGetters(['menuList', 'customer', 'project']),
    logoUrl() {
      return require('@/assets/logo.png')
    }
  },

  methods: {
    // 搜索
    search() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.$router.push({ name: 'Search', params: { scope: this.keyword.scope, content: this.keyword.content }})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header-wrap {
  width: 100%;
  background: url(../assets/imgs/top-bg.png) no-repeat;
  background-position-y: 0px;
  background-size: 100% 30px;
  padding: 50px 0 30px;
}

#app-header {
  width: 1200px;
  margin: 0 auto;

  .home {
    color: #000;
    &:hover {
      color: #986c33;
    }
  }

  .logo {
    height: 60px;
    float: left;
  }
}

.title-wrap {
  width: 400px;
  height: 60px;
  margin-top: -8px;
  float: left;

  .logo{
    width: 100%;
    text-align: left;

    img{
      // margin-top: 3px;
      height: 56px;
      width: 380px;
    }
  }
  a{
    text-decoration: none;
  }

  .title {
    text-align: left;
    // float: left;
    // width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 1px;
    font-family: Microsoft YaHei;
    // margin-top: 8px;
  }
}

.el-menu {
  float: left;
  width: 100%;
  border: none;
  .el-menu-item {
    background-color: rgba(0, 0, 0, 0.1);
    font-weight: bold;
    font-size: 16px;
  }

  .el-menu-item:hover {
    background-color: #986c33 !important;
    border-bottom: solid 2px #fff;
  }

  .is-active {
    background-color: #986c33 !important;
  }
}
.el-form {
  ::v-deep .search-input {
    width: 230px;
    height: 32px;

    .el-input__inner {
      border-top: none;
      border-bottom: none;
    }
  }
  ::v-deep .el-form-item__error {
    margin-left: 20px;
  }
}

.login-item{
  display: block;
  float:left;
  color:#fff;
  text-align: center;
  padding: 0 3px;
  width: 55px;
  overflow: hidden;
}
</style>
